/**
 * 画面選択した生協コードを格納するVO
 *
 * @export SelectCoopInfoModel
 * @class SelectCoopInfoModel
 */
export class SelectCoopInfoModel {
  // 設定画像配列
  /** 生協コード  */
  public selectCoopCode = String('');
}
